import { Component } from '@angular/core';

@Component({
  selector: 'ni-dialog-footer',
  template: '<ng-content></ng-content>'
})
export class DialogFooterComponent {}
